import { Model } from '@/models/Model';
import { DateTime } from 'luxon';
export class Event extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Event';
        this.$endpoint = '/events';
        this.$fillable = ['name', 'starts_at', 'ends_at', 'room', 'title', 'type', 'recurring', 'tags', 'lesson_type', 'description', 'is_chosen', 'is_mandatory', 'users', 'is_volitional_subjects_finished', 'is_volitional_subjects_unknown', 'is_volitional_subjects_active'];
    }
    get calendarEvent() {
        const parsedEvent = {
            id: this.id || '',
            title: this.title || '',
            start: this.starts_at ? DateTime.fromSQL(this.starts_at).toISO() : '',
            end: this.ends_at ? DateTime.fromSQL(this.ends_at).toISO() : '',
            extendedProps: {
                type: this.type,
                event: {
                    rooms: this.rooms || [],
                    subjects: this.subjects || [],
                    users: this.users || [],
                    levels: this.levels || [],
                    groups: this.groups || [],
                },
            },
            editable: true,
            className: `${this.type}__event`,
        };
        return parsedEvent;
    }
    get backgroundEvent() {
        const parsedEvent = {
            start: this.starts_at || '',
            end: this.ends_at || '',
            rendering: 'background',
        };
        return parsedEvent;
    }
    truncate(text, amount) {
        return `${text.substr(0, amount)}...`;
    }
    formatTime(property) {
        return DateTime.fromSQL(this[property]).toFormat('HH:mm');
    }
    attachSubjectsToEvent(eventId, subjects) {
        const url = `/events/${eventId}/relationships/subjects`;
        const payload = { subjects };
        return this.request('put', url, payload);
    }
    setIdAttribute(id) {
        this.id = id;
        return this;
    }
    choose(user, isChosen = true) {
        const url = this.$endpoint + '/' + this.resolvePrimaryKey() + '/relationships/users/' + user.id;
        return this.request('patch', url, { is_chosen: isChosen });
    }
    mandatory(payload) {
        const url = this.$endpoint + '/' + this.resolvePrimaryKey() + '/relationships/users/';
        return this.request('put', url, payload);
    }
    showInvitedStudents(id) {
        this.$endpoint = '/events/' + id + '/relationships/users';
        return this;
    }
    getInvitedStudents(id) {
        this.$endpoint = '/events/' + id + '/relationships/users';
        return this.request('get', this.$endpoint, {});
    }
}
